import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";

function AboutUsPage() {
  const { t } = useTranslation();

  return (
    <div
      className="about-page"
      style={{ padding: "4rem 2rem", maxWidth: "1100px", margin: "0 auto" }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "2rem" }}>
        {t("aboutUs.title")}
      </h1>

      <div style={{ display: "grid", gap: "2rem", alignItems: "center" }}>
        <img
          src="/images/team.png"
          alt={t("aboutUs.teamImageAlt")}
          style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}
        />

        <div>
          <h2 style={{ marginBottom: "1rem" }}>{t("aboutUs.missionTitle")}</h2>
          <p style={{ lineHeight: "1.8", fontSize: "1.1rem" }}>
            {t("aboutUs.missionDescription")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUsPage;
